import './style/styles-training.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/training'

Object.values(features).forEach(createComponent)
